import React, { useEffect, useState } from "react";
import { useFreeModeAuth } from "./auth/useFreeModeAuth.js";
import "./free-mode-banner.css";

const defaultFormState = {
  email: "",
  password: "",
  displayName: "",
};

const SignInSheet = ({ mode, onModeChange, onClose, onSubmit, status, error }) => {
  const [formState, setFormState] = useState(defaultFormState);

  useEffect(() => {
    setFormState(defaultFormState);
  }, [mode]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const payload = {
      email: formState.email.trim(),
      password: formState.password,
    };
    if (mode === "signup") {
      payload.displayName = formState.displayName.trim();
    }
    onSubmit(payload);
  };

  return (
    <div className="free-mode-sheet" role="dialog" aria-modal="true">
      <div className="free-mode-sheet__dialog">
        <header className="free-mode-sheet__header">
          <h2>{mode === "signup" ? "Create an account" : "Sign in"}</h2>
          <button
            type="button"
            className="free-mode-sheet__close"
            onClick={onClose}
            aria-label="Close sign-in dialog"
          >
            ×
          </button>
        </header>
        <form className="free-mode-sheet__form" onSubmit={handleSubmit}>
          {mode === "signup" && (
            <label className="free-mode-sheet__field">
              <span>Name</span>
              <input
                type="text"
                name="displayName"
                value={formState.displayName}
                onChange={handleChange}
                placeholder="Your name"
                autoComplete="name"
              />
            </label>
          )}
          <label className="free-mode-sheet__field">
            <span>Email</span>
            <input
              type="email"
              name="email"
              value={formState.email}
              onChange={handleChange}
              placeholder="you@example.com"
              autoComplete="email"
              required
            />
          </label>
          <label className="free-mode-sheet__field">
            <span>Password</span>
            <input
              type="password"
              name="password"
              value={formState.password}
              onChange={handleChange}
              autoComplete={mode === "signup" ? "new-password" : "current-password"}
              required
            />
          </label>
          {error ? <p className="free-mode-sheet__error">{error.message || String(error)}</p> : null}
          <button
            type="submit"
            className="free-mode-sheet__submit"
            disabled={status === "pending"}
          >
            {status === "pending"
              ? "Working…"
              : mode === "signup"
              ? "Create account"
              : "Sign in"}
          </button>
        </form>
        <footer className="free-mode-sheet__footer">
          {mode === "signup" ? (
            <button type="button" onClick={() => onModeChange("login")}>
              Already have an account? Sign in
            </button>
          ) : (
            <button type="button" onClick={() => onModeChange("signup")}>
              Need an account? Sign up
            </button>
          )}
        </footer>
      </div>
    </div>
  );
};

const FreeModeBanner = () => {
  const {
    shouldRender,
    sheetOpen,
    setSheetOpen,
    mode,
    setMode,
    status,
    error,
    handleSubmit,
  } = useFreeModeAuth();

  if (!shouldRender) {
    return null;
  }

  return (
    <div className="free-mode-banner">
      <span className="free-mode-banner__message">
        Free Mode — data stored locally. Sign in to back up &amp; sync.
      </span>
      <button
        type="button"
        className="free-mode-banner__button"
        onClick={() => setSheetOpen(true)}
      >
        Sign in
      </button>
      {sheetOpen ? (
        <SignInSheet
          mode={mode}
          onModeChange={setMode}
          onClose={() => setSheetOpen(false)}
          onSubmit={handleSubmit}
          status={status}
          error={error}
        />
      ) : null}
    </div>
  );
};

export default FreeModeBanner;
